<template lang="html">
  <section class="give-photo">
    <h1 class="tip">上传照片<span>（最多上传3张）</span></h1>
    <div class="upload">
      <div class="pic" v-for="(item, index) in pic">
        <img :src="item && item.src" @click="reUpload(index)" />
        <div class="delete" @click="deleteIt(index)">
          <i class="iconfont icon-lajitong"></i>
        </div>
        <div class="state" v-if="item && item.progress === 0 && item.finished">
          <span>上传失败，点击重试</span>
        </div>
        <div class="state" v-if="item && item.progress >= 0 && !item.finished">
          <span>上传中</span>
        </div>
        <div class="state" v-if="item && item.progress === 1">
          <span>上传成功</span>
        </div>
      </div>
      <div class="plus" v-show="rest !== 0">
        <i class="plus-icon"></i>
        <upload v-model="response" :rest="rest" :reload="reload" />
      </div>
    </div>
  </section>
</template>

<script>
import upload from './upload/index'

export default {
  components: {
    upload
  },
  props: {
    toSku: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      picView: [],
      pic: [],
      rest: 3,
      reload: {},
      response: {},
      newComment: {
        imageUrls: ''
      }
    }
  },
  watch: {
    response(value) {
      if (value.code === 1) {
        this.$$toast(value.msg)
      } else if (value.code === 2) {
        this.$$toast(value.msg)
      } else if (value.code === 3) {
        this.startUpload(value.pic)
      } else if (value.code === 4) {
        this.uploading(value.pic)
      } else if (value.code === 5 || value.code === 6) {
        this.uploaded(value.pic)
      } else if (value.code === 7 || value.code === 8) {
        this.$$toast(value.msg)
      }
    }
  },
  methods: {
    startUpload(pic) {
      this.pic.push(pic)
      this.pic.sort((a, b) => a.id - b.id)
      this.rest = 3 - this.pic.length
    },
    uploading(pic) {
      this.pic.forEach(v => {
        if (v.id === pic.id) {
          v.progress = pic.progress
        }
      })
    },
    uploaded(pic) {
      if (this.reload.fd) {
        this.reload = {}
      }
      this.pic.forEach(v => {
        if (v.id === pic.id) {
          v.progress = pic.progress
          v.finished = pic.finished
          v.dataPic = pic.dataPic
        }
      })
      this.getImages()
    },
    reUpload(index) {
      if (this.pic[index].progress === 0 && this.pic[index].fd) {
        this.reload = this.pic[index]
      }
    },
    deleteIt(index) {
      this.pic.splice(index, 1)
      this.rest = 3 - this.pic.length
      this.getImages()
    },
    getImages() {
      if (this.pic.length) {
        const arr = []
        this.pic.forEach(v => {
          const src = v.dataPic
          if (src) {
            arr.push(src)
          }
        })
        this.newComment.imageUrls = arr.join(',')
      } else {
        this.newComment.imageUrls = ''
      }
      if (this.toSku) {
        this.$store.commit('setNewComment', this.newComment)
      } else {
        this.$store.commit('setCommentObj', this.newComment)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/mixin';

.give-photo {
  background-color: #fff;
  padding-top: rem(60px);
  // padding: rem(20px);

  .tip {
    font-size: rem(28px);
    color: #121212;
    line-height: rem(30px);
    span {
      display: inline-block;
      font-size: rem(30px);
      color: #666;
      line-height: rem(30px);
    }
  }
  .upload {
    margin: rem(28px) 0;
    display: flex;
    flex-wrap: wrap;
    .pic {
      position: relative;
      z-index: 1;
      width: rem(158px);
      height: rem(158px);
      margin-left: rem(10px);
      &:first-child {
        margin-left: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .delete {
        position: absolute;
        z-index: 3;
        top: rem(10px);
        right: rem(10px);
        width: rem(45px);
        height: rem(45px);
        background-color: rgba(0, 0, 0, 0.6);
        text-align: center;
        .icon-lajitong {
          display: inline-block;
          font-size: rem(24px);
          color: #fff;
          line-height: rem(45px);
        }
      }
      .state {
        position: absolute;
        z-index: 2;
        bottom: 0;
        left: 0;
        width: 100%;
        // height: rem(35px);
        background-color: rgba(255, 57, 126, 0.8);
        text-align: center;
        span {
          display: inline-block;
          font-size: rem(26px);
          color: #fff;
          line-height: rem(35px);
        }
      }
    }
    .plus {
      @include border(all, #bbb, 1px, 4px, dashed);
      width: rem(158px);
      height: rem(158px);
      margin-left: rem(10px);
      font-size: rem(60px);
      &:first-child {
        margin-left: 0;
      }
      .plus-icon {
        position: relative;
        z-index: 2;
        display: inline-block;
        width: 100%;
        height: 100%;
        &::before {
          position: absolute;
          z-index: 3;
          top: 50%;
          left: 50%;
          margin-top: -0.5px;
          margin-left: rem(-40px);
          background-color: #ddd;
          width: rem(80px);
          height: 1px;
          content: ' ';
        }
        &::after {
          position: absolute;
          z-index: 99;
          top: 50%;
          left: 50%;
          margin-top: rem(-40px);
          margin-left: -0.5px;
          background-color: #ddd;
          width: 1px;
          height: rem(80px);
          content: ' ';
        }
      }
      .ui-upload-img {
        position: absolute;
        z-index: 4;
        top: 0;
        bottom: 0;
        width: 100%;
        font-size: 0;
        opacity: 0;
      }
    }
  }
}
</style>
